/* La Caza Cali — Drawer + Sticky Header JS (Phase 2.2)

   Pure vanilla, no dependencies. Loaded with <script defer> from
   sections/header.liquid so it runs after DOM parse.

   Responsibilities:
     - Drawer open/close via [data-drawer-toggle] / [data-drawer-close]
     - Escape key closes drawer + restores focus to toggle button
     - body.style.overflow lock while drawer is open (prevents background scroll)
     - aria-hidden + aria-expanded state management
     - Sticky header shadow: add .lacaza-header--scrolled when scrollY > 40
*/

(function () {
  'use strict';

  var body    = document.body;
  var drawer  = document.querySelector('[data-drawer]');
  var toggle  = document.querySelector('[data-drawer-toggle]');
  var header  = document.querySelector('[data-sticky]');
  var closeBtn = drawer ? drawer.querySelector('.lacaza-drawer__close') : null;

  /* ===== Drawer open/close ===== */

  function openDrawer() {
    body.classList.add('lacaza-drawer-open');
    body.style.overflow = 'hidden';
    if (drawer) drawer.setAttribute('aria-hidden', 'false');
    if (toggle) toggle.setAttribute('aria-expanded', 'true');
    /* Move focus into drawer for keyboard users */
    if (closeBtn) {
      requestAnimationFrame(function () { closeBtn.focus(); });
    }
  }

  function closeDrawer() {
    body.classList.remove('lacaza-drawer-open');
    body.style.overflow = '';
    if (drawer) drawer.setAttribute('aria-hidden', 'true');
    if (toggle) toggle.setAttribute('aria-expanded', 'false');
  }

  /* Single click delegate — covers toggle button + close button + scrim */
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-drawer-toggle]')) {
      e.preventDefault();
      if (body.classList.contains('lacaza-drawer-open')) {
        closeDrawer();
      } else {
        openDrawer();
      }
    } else if (e.target.closest('[data-drawer-close]')) {
      e.preventDefault();
      closeDrawer();
    }
  });

  /* Escape closes + returns focus to toggle */
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && body.classList.contains('lacaza-drawer-open')) {
      closeDrawer();
      if (toggle) toggle.focus();
    }
  });

  /* ===== Sticky header shadow on scroll ===== */

  var isScrolled = false;

  function updateSticky() {
    var nowScrolled = window.scrollY > 40;
    if (nowScrolled !== isScrolled) {
      isScrolled = nowScrolled;
      if (header) header.classList.toggle('lacaza-header--scrolled', isScrolled);
    }
  }

  window.addEventListener('scroll', updateSticky, { passive: true });
  updateSticky(); /* Run once on load to set initial state */
})();
